import { Injectable } from "@angular/core";
import { StakingBannerStateService } from "@modules/staking/domain/+state/staking-banner.state.service";
import { filter, take } from "rxjs/operators";
import { Observable } from "rxjs";
import { StakingBannerRemote } from "@modules/staking/domain/infrastructure/staking-banner.remote";
import { StakingBannerState } from "@modules/staking/domain/entities/staking-banner-state.model";
import { StakingFacade } from "@modules/staking/domain/+state/staking.facade";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";
import { UserService } from "@main-services/user.service";

@UntilDestroy()
@Injectable({
	providedIn: "root"
})
export class StakingBannerFacade {
	public constructor(
		private readonly stakingBannerRemote: StakingBannerRemote,
		private readonly stakingBannerStateService: StakingBannerStateService,
		private readonly stakingFacade: StakingFacade,
		private readonly userService: UserService
	) {
		if (this.userService.user.isVerified()) {
			this.fetchBannerData();
			this.stakingFacade
				.getStakeables$()
				.pipe(
					untilDestroyed(this),
					filter((stakeables: Stakeable[]) => stakeables.length !== 0)
				)
				.subscribe(() => {
					this.fetchBannerData();
				});
		}
	}

	public fetchBannerData(): void {
		this.stakingBannerRemote
			.fetchStakingBannerInfo()
			.pipe(take(1))
			.subscribe(
				(bannerState) => {
					this.stakingBannerStateService.updateState(bannerState);
				},
				() =>
					this.stakingBannerStateService.updateState({
						hasError: true,
						init: true,
						buttonKey: "try_again"
					})
			);
	}

	public getHighestYield$(): Observable<number> {
		return this.stakingBannerStateService.getHighestYield();
	}

	public getCurrentlyStaking$(): Observable<boolean> {
		return this.stakingBannerStateService.getCurrentlyStaking();
	}

	public getBannerStateData$(): Observable<StakingBannerState> {
		return this.stakingBannerStateService.getBannerState$();
	}
}
